export interface Notification {
  id: string;
  message: string;
  loading: boolean;
  type: NotificationTypeEnum;
  path: string | null;
}

export enum NotificationTypeEnum {
  WARNING = 0,
  INCONSISTENT = 1,
  STARTED = 2,
  FINALIZED = 3
}
